import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core'
import {faChevronRight} from '@fortawesome/pro-solid-svg-icons/faChevronRight'
import {IndustryOverviewPageSlug} from '../../../../core/content/types/industry-overview-page.types'
import {PUBLIC_ROUTES} from '../../../../shared/routing/public.routes'
import {SortingOption, SortingOptions} from '../../../../craft/sorting/sorting.types'
import {LinkService} from '../../../../core/i18n/link.service'
import {Observable} from 'rxjs'
import {map} from 'rxjs/operators'
import {defaultSortingOption, Order} from '../pro-directory-page.service'
import {TranslocoService} from '@ngneat/transloco'
import {IndustriesAndOfferings} from '../pro-directory-page.types'

@Component({
  selector: 'bgo-industries-and-offerings',
  templateUrl: './industries-and-offerings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [':host { display: block; }'],
  standalone: false,
})
export class IndustriesAndOfferingsComponent {
  @Input() industries: IndustriesAndOfferings[] | null = []
  @Output() sortingChanged = new EventEmitter<SortingOption>()

  protected readonly chevronRight = faChevronRight

  protected readonly sortingOptions$: Observable<SortingOptions> = this.translocoService
    .selectTranslateObject('proDirectoryPage.sortBy.alphabetical')
    .pipe(
      map(name => [
        {
          ...defaultSortingOption,
          name: name['asc'],
        },
        {
          value: Order.AlphabeticalDesc,
          name: name['desc'],
        },
      ]),
    )

  constructor(
    private readonly linkService: LinkService,
    private readonly translocoService: TranslocoService,
  ) {}

  getIndustryLink(i: {overviewPage: IndustryOverviewPageSlug}) {
    return this.linkService.localizedPathTo(PUBLIC_ROUTES.INDUSTRY_OVERVIEW_PAGE, {
      routeParams: {pageSlug: i.overviewPage.slug},
    })
  }

  getOfferingLink(offeringId: string, slug?: string) {
    const pageSlug = slug?.length ? slug : offeringId
    return this.linkService.localizedPathTo(PUBLIC_ROUTES.OFFERING_PAGE, {routeParams: {pageSlug}})
  }

  sort(option: SortingOption) {
    //temporarily clear industries (this will show loading skeleton until populated again)
    this.industries = null
    this.sortingChanged.emit(option)
  }
}
